import ApiBase from '../api-base'
export default class Menus extends ApiBase {
  constructor (store) {
    const path = 'admin/menus'
    super(store, path)
  }

  upsert (model, showProgress) {
    return this._request({
      method: 'PUT',
      body: model,
      showProgress
    })
  }
}
